require('./bootstrap');
require('./_global');
require('./components/vue-declarator');
require('./classes/global/GenericImageUpload');

// Load SortableJS for drag-and-drop functionality
window.Sortable = require('sortablejs').default || require('sortablejs');

require('./classes/global/ComponentManager');
require('../../../Fabrico/SoundStack/Business-AP/resources/js/classes/LabelArtistManager');

